import { Component } from "react";
import styles from "../../constants/Styles";
import { LocationMatch, LocationHistory } from "../../utils/NavUtils";
import { Link } from "../../utils/PostInternals";
import { getCircularReplacer } from "../../utils/SerializationUtils";
import { Button, Text, TextArea, View } from "../ui";
import { readLinkJSON } from "./utils/S3FileUtils";

interface LinkJSONProps {
  activeLink: Link | undefined;
  user: any;
  match: LocationMatch;
  history: LocationHistory;
  onChangeLink?: (link: Link) => void;
}

interface LinkJSONState {
  publishedText: any;
  showLink: boolean;
  draftText: string;
  importMessage: string;
  importError: boolean;
}

export class LinkJSON extends Component<LinkJSONProps, LinkJSONState> {
  constructor(props) {
    super(props);

    this.state = {
      publishedText: undefined,
      showLink: false,
      draftText: "",
      importMessage: "",
      importError: false,
    };
  }

  async componentDidMount() {
    const linkId = this.props.activeLink?.id;
    if (linkId) {
      const linkText = await readLinkJSON(linkId);
      if (linkText && linkText.trimStart().startsWith("{")) {
        try {
          const publishedText = JSON.stringify(
            JSON.parse(linkText),
            getCircularReplacer(),
            2
          );
          this.setState({ publishedText });
        } catch {
          // Not a valid JSON response (e.g. S3 returned an error XML for an
          // unpublished link). Leave publishedText undefined.
        }
      }
    }
  }

  importDraft = () => {
    // eslint-disable-next-line no-console
    console.log("[LinkJSON] importDraft clicked, draftText length=", this.state.draftText?.length);
    const { onChangeLink, activeLink } = this.props;
    const { draftText } = this.state;
    if (!onChangeLink) {
      this.setState({ importMessage: "Edit not enabled in this view.", importError: true });
      return;
    }
    if (!draftText?.trim()?.length) {
      this.setState({ importMessage: "Paste JSON in the field above first.", importError: true });
      return;
    }
    let parsed: Link;
    try {
      parsed = JSON.parse(draftText) as Link;
    } catch (e: any) {
      this.setState({ importMessage: `Invalid JSON: ${e?.message ?? e}`, importError: true });
      return;
    }
    if (activeLink?.id && parsed?.id && parsed.id !== activeLink.id) {
      this.setState({
        importMessage: `JSON id "${parsed.id}" does not match the link being edited "${activeLink.id}". Aborting.`,
        importError: true,
      });
      return;
    }
    onChangeLink(parsed);
    this.setState({
      importMessage: "Draft imported. Switch to the Save tab and Publish to push to S3.",
      importError: false,
      draftText: "",
    });
  };

  render() {
    const { activeLink, onChangeLink } = this.props;
    const { publishedText, showLink, draftText, importMessage, importError } = this.state;
    const jsonText = JSON.stringify(activeLink, getCircularReplacer(), 2);
    const noOfRows = jsonText?.split(/\r\n|\r|\n/)?.length;
    return (
      <View key="linkJSON" style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
        <View style={{ alignSelf: "end", margin: styles.margin }}>
          {publishedText ? (
            <Button
              title={`Show ${showLink ? "post" : "link"}`}
              onPress={() => this.setState({ showLink: !showLink })}
              type="clear"
            />
          ) : null}
        </View>
        {showLink ? (
          <TextArea
            key={"linkarea"}
            style={{ width: styles.drawWidth }}
            value={publishedText}
            rows={noOfRows}
            autoResize={true}
            readOnly={true}
          />
        ) : (
          <TextArea
            key={"postarea"}
            style={{ width: styles.drawWidth }}
            value={jsonText}
            rows={noOfRows}
            autoResize={true}
            readOnly={true}
          />
        )}

        {onChangeLink ? (
          <View style={{ width: styles.drawWidth, marginTop: styles.margin * 2 }}>
            <Text style={{ fontWeight: "bold", marginBottom: styles.margin }}>
              Paste JSON to replace draft
            </Text>
            <TextArea
              key={"importarea"}
              style={{ width: styles.drawWidth }}
              value={draftText}
              placeholder="Paste a full Link JSON here, then click Import to update the draft."
              rows={12}
              autoResize={false}
              onChange={(e: any) => this.setState({ draftText: e?.target?.value ?? "" })}
            />
            <View style={{ flexDirection: "row", alignItems: "center", marginTop: styles.margin }}>
              <button
                type="button"
                onClick={this.importDraft}
                style={{
                  padding: "8px 16px",
                  fontSize: 14,
                  cursor: "pointer",
                  background: "#2f95dc",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                }}
              >
                Import
              </button>
              {importMessage ? (
                <span style={{ marginLeft: styles.margin, color: importError ? "red" : "green" }}>
                  {importMessage}
                </span>
              ) : null}
            </View>
          </View>
        ) : null}
      </View>
    );
  }
}
